<script setup lang="ts">
import { useForm } from "@inertiajs/vue3";
import {
    apiPathUrl,
    isGuest,
    isVerified,
    mustBeLogin,
    mustBeVerified,
} from "@/Utils/helpers";
import AppLikeButton from "@/Components/App/likes/AppLikeButton.vue";
import AppReviewlikersModalButton from "@/Components/App/reviews/AppReviewLikersModalButton.vue";

type Props = {
    reviewId: string;
    apiPath: string;
    likesCount?: string | number;
    authHasLiked?: boolean;
    disabled?: boolean;
};

const {
    reviewId,
    apiPath,
    likesCount = 0,
    authHasLiked = false,
    disabled = false,
} = defineProps<Props>();

const form = useForm({});

// methods
const onClick = () => {
    if (isGuest.value) {
        mustBeLogin();
        return;
    }

    if (!isVerified.value) {
        mustBeVerified();
        return;
    }

    like();
};

const emit = defineEmits(["liked"]);

const like = () => {
    form.post(`${apiPathUrl(apiPath)}/like`, {
        preserveScroll: true,
        onSuccess: () => {
            emit("liked");
        },
    });
};
</script>

<template>
    <div class="flex items-center">
        <AppLikeButton
            :liked="authHasLiked"
            :loading="form.processing"
            :disabled="disabled"
            @click="onClick"
        />

        <AppReviewlikersModalButton
            :review-id="reviewId"
            size="xsmall"
            color="secondary"
            class="rounded-l-none"
            :disabled="likesCount === 0"
        >
            {{ likesCount }}
        </AppReviewlikersModalButton>
    </div>
</template>
